import { combineReducers } from '@reduxjs/toolkit';

import ids from './ids';
import advices from './advices';
import groupIds from './groupIds';

/**
 * @typedef {{
 *  advices: import('./advices').AdvicesState,
 *  ids: import('./ids').IdsState
 *  groupIds: import('./groupIds').GroupIdsState,
 * }} DataState
 */

export default combineReducers({
  ids,
  groupIds,
  advices,
});
